import React from "react";
import { Box, Tooltip } from "@mui/material";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";

export default function OverDueIconDesign({
  size = 30,
  color = "#4F46E5",
  onClick,
}) {
  return (
    <Tooltip title="Over Due" arrow>
      <Box
        sx={{
          width: size,
          height: size,
          backgroundColor: color,
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: onClick ? "pointer" : "default",
          "&:hover": {
            backgroundColor: "#fff",
            border: `2px solid ${color}`,
            "& .icon": {
              color: color,
            },
          },
        }}
        onClick={onClick}
      >
        <AccessTimeFilledIcon
          className="icon"
          sx={{
            color: "#fff",
            fontSize: size * 0.6,

            "&:hover": {
              backgroundColor: "#fff",
              border: `2px solid ${color}`,
              "& .icon": {
                color: color, // icon color matches border on hover
              },
            },
          }}
        />
      </Box>
    </Tooltip>
  );
}
